<template>
  <div class="row">
    <div class="col-12">
5      <label :for="`${id}_input`">{{ title }}</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i :class="icon + ' fa-fw'"></i>
          </span>
        </div>

        <select
          class="custom-select"
          :id="`${id}_input`"
          :name="name + '[]'"
          multiple
          style="height: 184px"
          ref="select"
          :required="required"
          :readonly="readonly"
          :disabled="disabled"
          :value="selectedIdsAsString"
          @change="handleChange"
        >
          <option
            v-for="item in listData"
            :key="item.id"
            :value="String(item.id)"
          >
            {{ item.alias || item.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    name: String,
    id: String,
    dataType: String,
    icon: String,

    required: {
      type: Boolean,
      default: true
    },

    readonly: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: true
    },

    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      listData: []
    };
  },

  computed: {
    selectedIdsAsString() {
      if (!Array.isArray(this.value)) {
        return [];
      }

      return this.value.map(id => String(id));
    }
  },

  mounted() {
    this.popData();
  },

  methods: {
    async popData() {
      try {
        let response;

        switch (this.dataType) {
          case "usersList":
            response = await axios.get("/release/userList");
            break;

          case "listQueue":
            response = await axios.get("/user/listQueue");
            break;

          case "listQueueChat":
            response = await axios.get("/user/listQueueChat");
            break;

          case "projects":
            response = await axios.get("/listProjects");
            break;

          default:
            this.listData = [];
            return;
        }

        this.listData = Array.isArray(response.data)
          ? response.data
          : [];
      } catch (error) {
        console.error("Erro ao carregar dados do multiselect:", error);
        this.listData = [];
      }
    },

    handleChange(event) {
      const selectedValues = Array.from(event.target.selectedOptions)
        .map(option => option.value);

      this.$emit("input", selectedValues);
    }
  }
};
</script>